import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, testId }) {
  return (
    <section
      className="relative border-b border-white/10 bg-[#0a0a0c] grid-noise"
      data-testid={testId || "page-header"}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-zinc-400 max-w-2xl text-base md:text-lg">
            {subtitle}
          </p>
        )}
        <div className="red-accent-line mt-8" />
      </div>
    </section>
  );
}
